import React from 'react';
import { ChatScreen } from '../shared/ChatScreen';

interface PatientChatScreenProps {
  onBack?: () => void;
}

export const PatientChatScreen = ({ onBack }: PatientChatScreenProps = {}) => {
  return <ChatScreen userRole="PATIENT" onBack={onBack}  chatUser={null}/>;
};
